import { localUrl as appLocalUrl } from './app-path.js';
import 'lazysizes';
import 'owl.carousel';
import Slugify from 'slugify';
import alertNews from './components/alert-news';
import { autocomplete } from './components/autocompletev2';
import cityBtnModal from './components/city-btn-modal';
import common from './components/common';
import geolocation from './components/geolocation';
import geolocationInstructionsModal from './components/geolocation-instructions-modal';
import header from './components/header';
import headerInfoBar from './components/header-info-bar';
import locationsModal from './components/locations-modal';
import sidebar from './components/sidebar';
import './monkey-patch';
const Main = {
	mapInstance: undefined,

	/**
	 * Carrosel
	 *
	 */
	initCarousel: () => {
		$('[data-owl-carousel]').each(function () {
			const items = $(this).data('items');
			const itemsMobile = $(this).data('items-mobile');

			let owl = {
				dots: true,
				lazyLoad: true,
				loop: true,
				touchDrag: true,
				responsive: {
					0: {
						items: itemsMobile || 1,
					},
					1024: {
						items,
					},
				},
			};

			if ($(this).data('autoplay')) {
				owl.autoplay = true;
				owl.autoplayTimeout = 5000;
				owl.rewind = true;
				owl.autoplayHoverPause = true;
			}

			$(this).owlCarousel(owl);
		});
	},
	/**
	 * Controla abertura dos subitens no menu mobile
	 *
	 */
	controlMobileMenu: () => {
		$(document).on('click', '.actControlMobileMenu', function () {
			const menu = $(this).data('menu');
			const after = $(this).data('after');

			$('#listSubMenusMobile.clone').remove();

			let $area = $('#listSubMenusMobile').clone().addClass('clone');

			$(`[data-sub-menu=${menu}]`).each(function () {
				let item = $(this).clone();

				$area.append(item);
			});

			$('.item-mobile').addClass('-opacity');
			$(this).removeClass('-opacity');

			$('[data-index-menu="' + after + '"]').after($area);
		});
	},
	/**
	 * Botão voltar ao header
	 *
	 */
	scrollUp: () => {
		$(document).on('click', '[data-arrow=goToUp]', function () {
			$('html, body').animate({ scrollTop: 0 }, 500);
		});
	},
	/**
	 * Modal de video de previsão e busca
	 *
	 */
	controlModal: () => {
		$(document).on('click', '.actControlModal', function () {
			const modal = $(this).data('modal');
			const modalElement = document.getElementById(`${modal}`);
			const hasInput = modalElement.querySelectorAll('input')[0];
			let activatedVideo = $('[data-video-modal]').hasClass('-activated');
			let renderedSearch = $('[data-search-modal]').hasClass('-rendered');

			if (modal === 'forecastVideo' && !activatedVideo) {
				$('[data-video-modal]').addClass('-activated');
				const videoId = $('#videoPlayerModal').data('video-id');

				/* build video iframe tag */
				var videoScript = document.createElement('iframe');
				videoScript.width = '100%';
				videoScript.height = '100%';
				videoScript.setAttribute('allowFullScreen', '');
				videoScript.frameborder = '0';
				videoScript.src = `https://www.youtube.com/embed/${videoId}`;

				let videoPlayer = document.getElementById('videoPlayerModal');
				videoPlayer.insertBefore(videoScript, videoPlayer.chilldNodes);
			}

			if (hasInput) hasInput.focus();
			$('.wrapper-modal, #' + modal).toggleClass('-active');
			$('body').toggleClass('_overflow-hidden');
		});

		$(document).on('click', '.actControlMapModal', function () {
			const mapModal = $(this).data('modal');

			$('.wrapper-modal.-inside, #' + mapModal).toggleClass('-active');
		});

		$(document).on('click', '.actCloseModal', function () {
			$('.wrapper-modal, .wrapper-modal.-inside, .modal-content').removeClass(
				'-active',
			);
			$('[data-menu=aside]').removeClass('-open');

			$('body').removeClass('_overflow-hidden');

			// remove iframe from tour's video
			$('#tourPlayerModal').find('iframe').remove();
		});

		$(document).on('click', '.actCloseModalNoRain', function () {
			const id = $(this).data('id');

			$(`#modalInfoNoRain${id}`).remove();
			$(`#modalInfoChart${id}`).remove();
		});

		$(document).on('click', '.act-control-mobile-search', function () {
			$(`[data-id='mobile-search']`).slideToggle('fast');
		});
	},
	/**
	 * Requisita ao usuário a sua localização
	 *
	 * @param callback
	 */
	getUserLocation: (callback, error) => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(callback, error);
		}
	},
	/**
	 * Muda comportamento da página se tiver banner background ativo
	 *
	 */
	renderBackgroundBanner: () => {
		let timer = setInterval(function () {
			if (
				!$(
					'[data-forecast-page="amanha"]' ||
						$(
							'[data-forecast-page="agora"]' || $('[data-forecast-page="fds"]'),
						),
				)
			) {
				// percorre divs que podem conter mega destaque
				$('[data-id="bannerMegaFeaturedForecast"]').each(function () {
					// se tiver bg, o iframe assume width maior que 1
					if ($(this).children().children().prop('width') > 1) {
						// acrescenta opacidade para mostrar o bg
						$(this).parent().addClass('-opacity');
						// empurra conteúdo da página para ajustar ao banner
						$('[data-id="mainContainer"]').addClass('has-mega-featured');
						// remove primeiro mega banner quando o bg estiver ativado
						$('[data-id="wrapperFirstBanner"]').css('display', 'none');
						// limpa o interval para não continuar percorrendo os banners
						clearInterval(timer);
						// remove a div do superbanner no topo
						$('[data-id="superBanner1"]').remove();
					}
				});
			}
		}, 2000);
	},
	/**
	 * Varre divs de selo (patrocínio) e habilita as que tiverem banner ativo
	 *
	 */
	renderSeal: () => {
		setTimeout(() => {
			$('[data-selo]').each(function () {
				if ($(this).children().children() !== 'script') {
					$(this).parent().addClass('_none');

					if (
						$(this).children().children().prop('width') &&
						$(this).css('display') !== 'none'
					) {
						$(this).parent().removeClass('_none');
					} else {
						$(this).parent().removeClass('_flex-md');
					}
				}
			});
		}, 3000);
	},
	/**
	 * Controla modal de notícias dos usuários
	 *
	 */
	controlNewsModal: () => {
		$(document).on('click', '[data-open-article]', function () {
			const id = $(this).data('open-article');

			$('[data-article]').addClass('_none');
			$('[data-article=' + id + ']').removeClass('_none');
		});
	},
	/**
	 * Controla eventos de scroll na página (lazyload)
	 *
	 */
	onScroll: () => {
		$('[data-map]').each(function () {
			Main.renderMap();
		});

		const stickBannerMobile = $('[data-banner=stickBannerMobile');

		let stickBannerMobileTop = 0;
		let stickBannerMobileEnd = 0;

		if (stickBannerMobile.length) {
			stickBannerMobileTop = stickBannerMobile.offset().top;
			stickBannerMobileEnd = $('[data-end-sticky-banner]').offset().top;
		}

		document.addEventListener(
			'scroll',
			function (e) {
				let scroll = $(window).scrollTop();

				if (stickBannerMobile.length) {
					/**
					 * BEGIN: sticky banner mobile
					 */
					if (scroll >= stickBannerMobileTop) {
						stickBannerMobile.addClass('_fixed');
					} else {
						stickBannerMobile.removeClass('_fixed');
					}

					if (scroll >= stickBannerMobileEnd + 60) {
						stickBannerMobile.addClass('-hidden');
					} else {
						stickBannerMobile.removeClass('-hidden');
					}
					/**
					 * END: sticky banner mobile
					 */
				}

				if (scroll > 300) {
					$('[data-banner="stickBanner"]').addClass('-active');
				} else {
					$('[data-banner="stickBanner"]').removeClass('-active');
				}

				$('[data-counter]').each(function () {
					let offset = $(this).offset().top - 300;
					let activated = $(this).hasClass('-activated');

					if (scroll > offset && !activated) {
						const total = $(this).data('total');

						$(this).addClass('-activated');
						$(this)
							.prop('counter', 0)
							.animate(
								{ counter: total },
								{
									duration: 2500,
									easing: 'swing',
									step: function (now) {
										$(this).text(Math.ceil(now));
									},
								},
							);
					}
				});

				$('[data-map-lazyload]').each(function () {
					let offsetMap = $(this).offset().top - 500;
					let activatedMap = $(this).hasClass('-activated');

					if (scroll > offsetMap && !activatedMap) {
						$(this).addClass('-activated');
						Main.renderMap();
					}
				});

				$('[data-youtube-playlist]').each(function () {
					let offsetVideo = $(this).offset().top - 900;
					let activatedVideo = $(this).hasClass('-activated');

					if (scroll > offsetVideo && !activatedVideo) {
						let iframe = document.createElement('iframe');

						$(this).addClass('-activated');
						iframe.setAttribute(
							'src',
							'https://www.youtube.com/embed/videoseries?list=PLxmGWMXKfr9pS5844TEB2m9zwnzARvGNx',
						);
						iframe.setAttribute('width', '100%');
						iframe.setAttribute('heigth', '100%');
						iframe.setAttribute('frameborder', '0');

						$(this).append(iframe);
					}
				});
			},
			{ passive: true },
		);
	},
	/**
	 * Renderiza mapa
	 * TODO: Retirar método do main e criá-lo na controller de Brazil e Forecast
	 * @param lat
	 * @param lon
	 * @returns {boolean}
	 */
	renderMap: async (lat = null, lon = null) => {
		const idCity = document
			.getElementById('mainContent')
			.getAttribute('data-id-city');
		const forecastPage = $('#mainContent').data('forecast-page');
		let options;

		if (forecastPage === 'brasil') {
			options = {
				center: [-15.78, -47.93],
				zoom: 4,
			};
		}

		const { default: MapCabuloso } = await import(
			/* webpackChunkName: "mapLazyModule" */
			'./components/Map'
		);

		Main.mapInstance = new MapCabuloso('mapCabuloso', options);

		const { mapInstance } = Main;
		const { map } = mapInstance;

		if (lat && lon) {
			return void map.setView([lat, lon]);
		}

		const url = appLocalUrl('/info?id=') + idCity;
		const xhttp = new XMLHttpRequest();
		xhttp.onreadystatechange = function () {
			if (this.readyState == 4 && this.status == 200) {
				const cityData = JSON.parse(this.response);

				// In case it returns an empty response
				if (Array.isArray(cityData)) return;

				const { latitude, longitude, city, uf } = cityData;
				const latlng = [latitude, longitude];

				map.setView(latlng);
				mapInstance.addCityMarker(latlng, `${city} - ${uf}`);
			}
		};

		xhttp.open('GET', url, true);
		xhttp.send();
	},

	/**
	 * Adiciona autocomplete de localidades para inputs necessários
	 * TODO: Desmembrar método responsável pelo autocommplete do topo e mapas
	 */
	autocompleteSearchV2: () => {
		autocomplete();
	},
	/**
	 * Fecha banner
	 */
	closeBanner: () => {
		$(document).on('click', '[data-close-banner]', function () {
			$(this).parent().remove();
		});
	},
	/**
	 * Controla os banners fixos
	 *
	 */
	controlFixedSideBanner: () => {
		// se tiver banner fixo lateral
		if ($('#wrapperSideBanner').length) {
			document.addEventListener(
				'scroll',
				function (e) {
					const wrapperSideBanner = $('#wrapperSideBanner');
					const sideBanner = $('#sideBanner');
					const wrapperSideBannerTop = wrapperSideBanner.offset().top;
					const wrapperSideBannerHeight = wrapperSideBanner.height();
					const wrapperSideBannerTotal =
						wrapperSideBannerTop + wrapperSideBannerHeight;
					const sideBannerHeight = sideBanner.height();
					let scrollPosition = wrapperSideBannerTotal - sideBannerHeight;
					let windowTop = $(window).scrollTop();

					if (windowTop >= scrollPosition)
						sideBanner
							.addClass('-absolute-banner')
							.removeClass('-fixed-banner');
					else if (windowTop >= wrapperSideBannerTop)
						sideBanner
							.addClass('-fixed-banner')
							.removeClass('-absolute-banner');
					else
						sideBanner
							.removeClass('-fixed-banner')
							.removeClass('-absolute-banner');

					if (sideBanner.hasClass('-fixed-banner')) sideBanner.css('top', '0');
					else sideBanner.css('top', 'auto');
				},
				{ passive: true },
			);
		}
	},
	/**
	 * Requisita informações do usuário logado e monta menu no header
	 *
	 */
	controlLoggedMenu: () => {
		$(document).on('click', '.act-control-logged-menu', function (e) {
			e.preventDefault();

			$('[data-modal=user-logged-menu]').toggleClass('_none');
		});
	},
	/**
	 * Lista de localidades favoritas na barra de breadcrumb
	 *
	 */
	controlModalListBreadcrumb: () => {
		$(document).on(
			'click',
			'.act-control-favorites-locales-breadcrumb',
			function (e) {
				e.preventDefault();

				$('[data-id=list-favorites-locales-breadcrumb]').toggleClass('-active');
			},
		);
	},
	/**
	 * Contabiliza cliques no GA nos elementos selecionados
	 *
	 */
	initMetrics: () => {
		$(document).ready(function () {
			$('.actTriggerGA').click(function () {
				const category = $(this).data('category');
				const label = $(this).data('label');
				const action = $(this).data('action');

				// ga('send', {
				//   hitType: 'event',
				//   eventCategory: category,
				//   eventAction: action,
				//   eventLabel: label
				// });
			});
		});
	},
	/**
	 * Controla evento de click dos accordions
	 * Forecast Weekend, Fifteen Days, Favorites Locales (My Climatempo)
	 */
	controlAccordion: () => {
		$(document).on('click', '.actOpenAccordion', function (e) {
			if (['IMG', 'BUTTON'].includes(e.target.tagName)) return;

			const accordion = $(this).data('accordion');

			$('[data-id=accordion' + accordion + ']').toggleClass('_none');

			$(this).find('.accordion-icon').toggleClass('-active');
			$(this).find('.simple-arrow').toggleClass('-down');
			$(this).toggleClass('-down');
		});
	},
	/**
	 * Render a list with forecast now for all favorites locales
	 * Header in all pages
	 */
	renderWeatherNowByFavoritesLocalesBreadcrumb: () => {
		const isLogged = document.cookie.match(new RegExp('(^| )SESSID=([^;]+)'));
		const url = appLocalUrl(`/json/myclimatempo/user/weatherNowByFavoritesLocales?${Math.random(
			1,
			1000,
		)}`);

		if (isLogged) {
			const xhttp = new XMLHttpRequest();
			try {
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						try {
							const response = JSON.parse(this.response);

							response.forEach(item => {
								let locale = item.data[0].locale;
								let weather = item.data[0].weather[0];
								let slug = Main.createSlug(locale.name);
								let acronym = locale.acronym;

								if (locale.acronym == 'BR') acronym = locale.uf;

								const url = `${locale.city}/${slug}-${acronym.toLowerCase()}`;
								const cityName = `${locale.name}, ${acronym}`;

								// item = `<li class="item" style="z-index: 999;">
								//           <img class="icon" src="/dist/images/v2/svg/outline/${
								//             weather.icon
								//           }.svg" width="20" height="20" alt="Ícone de temperatura atual">
								//           <a href="/previsao-do-tempo/cidade/${url}" class="-white">
								//             ${cityName}
								//             /
								//             ${weather.temperature}&deg;
								//           </a>
								//         </li>`;

								item = `<li class="item" style="z-index: 999;">
                          <a href="${appLocalUrl(`/previsao-do-tempo/cidade/${url}`)}" class="-white">
                            ${cityName}
                            /
                            ${weather.temperature}&deg;
                          </a>
                        </li>`;

								$('[data-id=list-favorites-locales-breadcrumb')
									.append(item)
									.removeClass('_none');
								$('[data-id=list-favorites-locales-arrow').removeClass('_none');
							});
						} catch (e) {}
					}
				};

				xhttp.open('GET', url, true);
				xhttp.send();
			} catch (e) {
				messageStatusRegister.html('Houve um erro, tente mais tarde');
			}
		}
	},

	/**
	 * Sync favorited locales from mobile device to web
	 */
	syncFavLocalesPushNotification: () => {
		const isLogged = document.cookie.match(new RegExp('(^| )SESSID=([^;]+)'));
		const isSyncToday = document.cookie.match(
			new RegExp('(^| )syncToday=([^;]+)'),
		);

		if (isLogged && !isSyncToday) {
			const url = appLocalUrl(`/json/myclimatempo/user/getChannels`);
			const xhttp = new XMLHttpRequest();
			const now = new Date();

			try {
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						const userChannels = JSON.parse(this.response);
						userChannels.map(channel => {
							const topic = `BR_RAIN_${Main.convertRegion(channel.region)}_${
								channel.uf
							}_${channel.localeId}`;
							const enabled = channel.active ? 1 : 0;
							// Se inscreve no PushNews
							Main.pushSubscription(topic, enabled);
						});
					}
				};

				xhttp.open('GET', url, true);
				xhttp.send();
			} catch (e) {}

			now.setTime(now.getTime() + 12 * 3600 * 1000); // lifetime: 12 hours
			document.cookie =
				'syncToday=true; expires=' + now.toUTCString() + '; path=/';
		}
	},
	convertRegion: region => {
		const dicionary = {
			n: 'N',
			ne: 'NE',
			e: 'E',
			se: 'SE',
			s: 'S',
			so: 'SW',
			o: 'W',
			ne: 'NW',
			co: 'MW',
		};

		return dicionary[region.toLowerCase()]
			? dicionary[region.toLowerCase()]
			: region.toUpperCase();
	},
	/**
	 * Ask for geolocation position and get locale id
	 *
	 */
	userGeolocation: () => {
		geolocation.userGeolocation();
	},
	/**
	 * Create slug from string
	 *
	 */
	createSlug: string => {
		const slug = Slugify(string, {
			remove: /[ \']/g,
			url: true,
			lower: true,
		});

		return slug;
	},
	pushSubscription: (channel, value) => {
		// Send subscription to Push News
		IlabsPush.sendCustomFilters({ [channel]: value });
	},
	/**
	 * Create a dynamic link for menus
	 */
	dynamicLink: (idcity, name, uf) => {
		const slugBody = $('body').data('slug');
		const slugBreadcrumb = `${idcity}/${Main.createSlug(
			name,
		)}-${uf.toLowerCase()}`;

		const slug = slugBody ? slugBody : slugBreadcrumb;

		$('[data-dynamic-link]').each(function () {
			let href = $(this).data('link').replace('{slug}', slug);
			$(this).attr('href', appLocalUrl(href));
		});
	},
	dynamicNewsLink: () => {
		$('[data-dynamic-news-link]').each(function () {
			const widthScreen = $(window).width();
			const href = $(this).data('link');
			let prefix = appLocalUrl('/noticia');

			if (href.startsWith('https://agroclima.climatempo.com.br/')) {
				console.log(href);
				$(this).attr('href', `${href}`);
			} else {
				$(this).attr('href', `${prefix}/${href}`);
			}
		});

		$('[data-dynamic-agroclima-news-link]').each(function () {
			const href = $(this).data('link');
			const url = href.startsWith('https://agroclima.climatempo.com.br/')
			  ? href
			  : `https://agroclima.climatempo.com.br/noticia/${href.replace(/^\/+/, '')}`;
			$(this).attr('href', url);
		});
	},
	/**
	 * Carrosel de notícias em tempo real
	 * Forecast Today
	 */
	controlCarousel: () => {
		const owl = $('[data-carousel-name="realTime"]');

		$('.-owl-next').click(function () {
			owl.trigger('next.owl.carousel');
		});

		$('.-owl-prev').click(function () {
			owl.trigger('prev.owl.carousel');
		});
	},
	init: () => {
		sidebar.init();
		Main.initCarousel();
		Main.scrollUp();
		Main.controlModal();
		Main.renderBackgroundBanner();
		Main.renderSeal();
		Main.controlNewsModal();
		Main.onScroll();
		Main.autocompleteSearchV2();
		Main.closeBanner();
		Main.controlFixedSideBanner();
		Main.controlMobileMenu();
		Main.controlLoggedMenu();
		Main.initMetrics();
		Main.controlAccordion();
		Main.userGeolocation();
		Main.controlModalListBreadcrumb();
		Main.syncFavLocalesPushNotification();
		Main.dynamicNewsLink();
		Main.controlCarousel();
		alertNews.getNewestAlert();
		alertNews.closeAlert();
		header.controlMenu();
		common.autocompleteSearchV2();
		common.applyDataStyleAttributes();
		common.applyWindRotationIndicators();
		common.bindMoreDaysButtons();
		common.viewData();
		common.setAlertStyle();
		locationsModal.init();
		geolocationInstructionsModal.init();
		cityBtnModal.init();
		headerInfoBar.init();
		locationsModal.init();
		geolocationInstructionsModal.init();
	},
};

export default Main;
